import app from './app';
import GambitManager from './GambitManager';
export default class SearchManager {
  /**
   * The minimum query length before sources are searched.
   */
  static MIN_SEARCH_LEN = 3;

  /**
   * Whether experimental CJK search mode is enabled.
   */
  static isCjkMode() {
    const settings = app.data.settings;
    return settings?.['search_cjk_mode'] ?? false;
  }

  /**
   * The minimum query length for the current forum. Experimental CJK search mode
   * drops it to 1, since a single character is often a whole word in languages
   * without word spaces; the substring match backing that mode has no minimum.
   */
  static minSearchLength() {
    return this.isCjkMode() ? 1 : this.MIN_SEARCH_LEN;
  }

  /**
   * Time to wait (in milliseconds) after the user stops typing before triggering a search.
   */
  static SEARCH_DEBOUNCE_TIME_MS = 250;

  /**
   * An object which stores previously searched queries and provides convenient
   * tools for retrieving and managing search values.
   */

  /**
   * The gambit manager that will convert search query gambits
   * into API filters.
   */
  gambits = (() => new GambitManager())();
  constructor(state) {
    this.state = state;
  }
}
flarum.reg.add('core', 'common/SearchManager', SearchManager);